type AuthCardProps = {
  children: React.ReactNode;
};

export const AuthCard: React.FC<AuthCardProps> = ({ children }) => {
  return (
    <div className='sm:mx-auto sm:w-full sm:max-w-[480px]'>
      <div className='bg-white px-6 py-12 shadow-sm sm:rounded-lg sm:px-12'>
        {children}
      </div>
    </div>
  );
};
